/**
 * @owner @Appboy/push
 */

import { z } from "zod";

// Canonical iOS interruption level values from shared_constants.json IOS_INTERRUPTION_LEVEL,
// codified in shared_code/lib/shared/shared_constants.json.
export const interruptionLevelSchema = z.enum(["passive", "active", "time-sensitive", "critical"]);
